export default __webpack_public_path__ + "static/media/sidebar-5.3a58a90c.jpg";